(function($){

    // -------------------------
    // Thumb window helpers (shared)
    // -------------------------
    var VISIBLE = 6; // window size
  
    function ensureTrack($thumbs){
      if (!$thumbs.children('.thumb-track').length) {
        $thumbs.wrapInner('<div class="thumb-track"></div>');
      }
      return $thumbs.children('.thumb-track');
    }
    function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }
    function calcOffsetPx($track, startIndex){
      var $children = $track.children('.thumb');
      if (!$children.length) return 0;
      var firstRect = $children.eq(0)[0].getBoundingClientRect();
      var startRect = $children.eq(startIndex)[0].getBoundingClientRect();
      return -(startRect.left - firstRect.left);
    }
    function getStart($gallery){ return Number($gallery.data('thumbStart')) || 0; }
    function setStart($gallery, s){ $gallery.data('thumbStart', s); }
  
    function applyWindow($gallery, startIndex){
      var $thumbs = $gallery.find('.thumbs');
      var $track  = ensureTrack($thumbs);
      var $items  = $track.children('.thumb');
      var maxStart = Math.max(0, $items.length - VISIBLE);
      var s = clamp(startIndex, 0, maxStart);
      var tx = calcOffsetPx($track, s);
      $track.css('transform', 'translateX(' + tx + 'px)');
      setStart($gallery, s);
    }
  
    // Ensure a given index is visible inside the window; minimal scroll
    function ensureIndexVisible($gallery, index){
      var $thumbs = $gallery.find('.thumbs');
      var $track  = ensureTrack($thumbs);
      var total   = $track.children('.thumb').length;
      if (total <= VISIBLE) return;
  
      var s = getStart($gallery);
      var leftEdge  = s;
      var rightEdge = s + VISIBLE - 1;
  
      if (index > rightEdge) {
        s = index - (VISIBLE - 1); // bring to right edge
        applyWindow($gallery, s);
      } else if (index < leftEdge) {
        s = index; // bring to left edge
        applyWindow($gallery, s);
      }
    }
  
    // -------------------------
    // Main gallery + integration
    // -------------------------
  (function($){
    const TRANSITION_MS = 300;
  
    function ensureSlidesTrack($gallery){
      const $slidesWrap = $gallery.find('.slides').first();
      if (!$slidesWrap.length) return null;
  
      let $track = $slidesWrap.children('.slides-track');
      if (!$track.length){
        $slidesWrap.addClass('is-track');
  
        $track = $('<div class="slides-track"></div>');
        // move any existing media nodes into .slide containers
        $slidesWrap.children(':not(.slides-track)').each(function(){
          const $node = $(this);
          if ($node[0].nodeType !== 1) return; // only element nodes
          const $slide = $('<div class="slide"></div>');
          $node.appendTo($slide);
          $track.append($slide);
        });
  
        $slidesWrap.empty().append($track);
      }
      const $items = $track.children('.slide');
      return { $wrap: $slidesWrap, $track, $items };
    }
  
    function setTransform($el, index, withAnim){
      $el.css('transition', withAnim ? `transform ${TRANSITION_MS}ms ease` : 'none')
         .css('transform', `translateX(-${index * 100}%)`);
    }
  
    $(document).ready(function () {
      $('.bundle_gallery').each(function () {
        const $gallery     = $(this);
        const $bullets     = $gallery.find('.bullets');
        const $thumbsWrap  = $gallery.find('.thumbs');
  
        ensureTrack($thumbsWrap); // your existing thumbs helper
        const $thumbButtons = $thumbsWrap.find('.thumb');
        const hasThumbs     = $thumbButtons.length > 0;
  
        // Build sliding layout
        const built = ensureSlidesTrack($gallery);
        if (!built) return;
        const { $wrap, $track, $items } = built;
        const total = $items.length;
        if (!total) return;
  
        let currentIndex = 0;
  
        // initial paint (no animation)
        setTransform($track, 0, false);
        applyWindow($gallery, 0); // your existing thumbs window logic
  
        function showSlide(index){
          if (index < 0) index = (index + total) % total;
          if (index >= total) index = index % total;
  
          setTransform($track, index, true);
  
          if (hasThumbs){
            $thumbButtons.removeClass('active').eq(index).addClass('active');
            ensureIndexVisible($gallery, index);
          } else if ($bullets.length){
            $gallery.find('.bullet').removeClass('active').eq(index).addClass('active');
          }
  
          currentIndex = index;
          $('.bundle_gallery.desktop').trigger('sticky:recalc');
        }
  
        // Rebuild bullets if needed
        if ($bullets.length && !hasThumbs){
          $bullets.empty();
          for (let i = 0; i < total; i++){
            const $b = $('<span class="bullet"></span>');
            if (i === 0) $b.addClass('active');
            $b.on('click', function(){ showSlide(i); });
            $bullets.append($b);
          }
        }
  
        // Thumbs click
        if (hasThumbs){
          $thumbButtons.each(function(){
            const i = parseInt($(this).attr('data-index'), 10);
            $(this).on('click', function(){ showSlide(i); });
          });
        }
  
  
        // Swipe
        let startX = 0, endX = 0;
        $wrap.on('touchstart', function(e){ startX = e.originalEvent.touches[0].clientX; });
        $wrap.on('touchend',   function(e){
          endX = e.originalEvent.changedTouches[0].clientX;
          if (endX < startX - 30)      showSlide(currentIndex + 1);
          else if (endX > startX + 30) showSlide(currentIndex - 1);
        });
  
        // Keep current slide on resize + keep thumbs window aligned
        let pending = false;
        $(window).off('resize.thumbsync').on('resize.thumbsync', function(){
          if (pending) return;
          pending = true;
          requestAnimationFrame(function(){
            pending = false;
            setTransform($track, currentIndex, false);
            applyWindow($gallery, getStart($gallery));
          });
        });
  
        // Thumb edge nudge (unchanged)
        $thumbsWrap.off('click.thumbwin').on('click.thumbwin', 'button.thumb', function(){
          const $btn = $(this);
          const $t = ensureTrack($thumbsWrap);
          const $itemsT = $t.children('.thumb');
          const totalT = $itemsT.length;
          if (totalT <= VISIBLE) return;
  
          let s = getStart($gallery);
          const idx = $itemsT.index($btn);
          const leftEdge  = s;
          const rightEdge = s + VISIBLE - 1;
  
          if (idx >= rightEdge - 1 && (s + VISIBLE) < totalT) {
            s += 1;
            applyWindow($gallery, s);
          } else if (idx <= leftEdge + 1 && s > 0) {
            s -= 1;
            applyWindow($gallery, s);
          }
        });
  
        // expose for external calls
        $gallery.data('showSlide', showSlide);
      });
  
      // Fixed desktop gallery logic. This mirrors the product gallery behavior:
      // calculate immediately, then keep the gallery between the top and bottom
      // of the taller right-hand product column.
      (function initFixedBundleGallery() {
        var $gallery = $('.bundle_gallery.desktop').first();
        var $left = $gallery.closest('.bundle_left');
        var $right = $left.siblings('.bundle_right').first();
        var framePending = false;
  
        if (!$gallery.length || !$left.length || !$right.length) return;
  
        // Prevent the old Sticky instance from competing with this handler.
        if (window.sticky && typeof window.sticky.destroy === 'function') {
          window.sticky.destroy();
        }
  
        function clearFixedGallery() {
          $gallery.removeClass('fixed_gallery').css({
            position: '',
            top: '',
            right: '',
            bottom: '',
            left: '',
            width: ''
          });
          $left.css({
            position: ''
          });
          $left[0].style.removeProperty('min-height');
        }
  
        function updateFixedGallery() {
          framePending = false;
  
          if ($(window).width() < 768 || !$gallery.is(':visible')) {
            clearFixedGallery();
            return;
          }
  
          var containerHeight = $left.innerHeight();
          var galleryHeight = $gallery.outerHeight();
  
          if (!containerHeight || !galleryHeight || containerHeight < galleryHeight) {
            clearFixedGallery();
            return;
          }
  
          $gallery.addClass('fixed_gallery');
          $left.css('position', 'relative');
          $left[0].style.removeProperty('min-height');
  
          var scrollTop = $(window).scrollTop();
          var leftTop = $left.offset().top;
          var maxTop = Math.max(0, containerHeight - galleryHeight);
          var leftRect = $left[0].getBoundingClientRect();
  
          if (scrollTop <= leftTop) {
            $gallery.css({
              position: 'absolute',
              top: '0',
              right: 'auto',
              bottom: 'auto',
              left: '0',
              width: '100%'
            });
          } else if (scrollTop >= leftTop + maxTop) {
            $gallery.css({
              position: 'absolute',
              top: maxTop + 'px',
              right: 'auto',
              bottom: 'auto',
              left: '0',
              width: '100%'
            });
          } else {
            $gallery.css({
              position: 'fixed',
              top: '0',
              right: 'auto',
              bottom: 'auto',
              left: leftRect.left + 'px',
              width: leftRect.width + 'px'
            });
          }
        }
  
        function requestFixedGalleryUpdate() {
          if (framePending) return;
          framePending = true;
          requestAnimationFrame(updateFixedGallery);
        }
  
        $(window)
          .off('scroll.fixedBundleGallery resize.fixedBundleGallery orientationchange.fixedBundleGallery')
          .on('scroll.fixedBundleGallery', requestFixedGalleryUpdate)
          .on('resize.fixedBundleGallery orientationchange.fixedBundleGallery', updateFixedGallery);
  
        $('.next_step button, .last_step_block button')
          .off('click.fixedBundleGallery')
          .on('click.fixedBundleGallery', function() {
            setTimeout(updateFixedGallery, 0);
          });
  
        updateFixedGallery();
      })();
    });
  })(jQuery);
  
  })(jQuery);
  
  // Variant Items Info
  $(document).ready(function () {
  
    $('.info_button').click(function () {
      var modalImgURL = $(this).data('modal-img');
      var modalTitle = $(this).data('modal-title');
      var modalText = $(this).data('modal-text');
      var modalID = $(this).data('id');
      $('.bundle_modal_box h4').text(modalTitle);
      $('.bundle_modal_box p').text(modalText);
      $('.bundle_modal_box .modal_image').attr('src', modalImgURL);
      $('.bundle_modal_box .modal_add').attr('data-id', modalID);
      $('.bundle_modal .modal_add').show();
      $('.bundle_modal').fadeIn();
    });
  
    $('.info').click(function () {
      var modalImgURL = $(this).nextAll('.info_button').data('modal-img');
      var modalTitle = $(this).nextAll('.info_button').data('modal-title');
      var modalText = $(this).nextAll('.info_button').data('modal-text');
      var modalID = $(this).nextAll('.info_button').data('id');
      $('.bundle_modal_box h4').text(modalTitle);
      $('.bundle_modal_box p').text(modalText);
      $('.bundle_modal_box .modal_image').attr('src', modalImgURL);
      $('.bundle_modal_box .modal_add').attr('data-id', modalID);
      $('.bundle_modal .modal_add').show();
      $('.bundle_modal').fadeIn();
    });
  
  });
  
  $(document).ready(function () {
  
    // Step toggle
    
    $('.next_step button').click(function () {
      $('body').addClass('second_step_active');
      setTimeout(function () {
        $('body').addClass('allow_gift_updates');
      }, 500);
      $('.bunde-lp-section').hide();
      $('#lp_topbar_2').show();
      $('.checkout_button_wrapper').css({
        visibility: 'visible',
        height: 'auto'
      });
      updatePrevStepButton();
      setTimeout(function () {
          updateCheckoutButton();
      }, 100);
      $('.guarantee_block').show();
    });
    
    $('.sticky_button button').click(function () {
      $('body').addClass('second_step_active');
      setTimeout(function () {
        $('body').addClass('allow_gift_updates');
      }, 500);
      $('.bunde-lp-section').hide();
      $('#lp_topbar_2').show();
      $('.checkout_button_wrapper').css({
        visibility: 'visible',
        height: 'auto'
      });
      updatePrevStepButton();
      setTimeout(function () {
          updateCheckoutButton();
      }, 100);
      $('.guarantee_block').show();
    });
    
    $('.prev_step button').click(function () {
      $('body').removeClass('second_step_active');
      $('.bunde-lp-section').show();
      $('#lp_topbar_2').hide();
      $('.checkout_button_wrapper').css({
        visibility: 'hidden',
        height: '0'
      });
    });
    
    $('.last_step_block button').click(function () {
      $('body').removeClass('second_step_active');
      $('.bunde-lp-section').show();
      $('#lp_topbar_2').hide();
      $('.checkout_button_wrapper').css({
        visibility: 'hidden',
        height: '0'
      });
      $('.guarantee_block').hide();
    });
  
  });
  
  $(document).ready(function() {
      $(window).on('scroll', function() {
          var windowHeight = $(window).height();
          var documentHeight = $(document).height();
          var scrollTop = $(window).scrollTop();
  
          var bottomScrollPosition = scrollTop + windowHeight;
          var scrollFromBottom = documentHeight - bottomScrollPosition;
  
          var topDistance1 = $('.bundle_left').height();
          var topDistance2 = $('#step_height_2').height();
          var topDistanceTotal = topDistance1 + topDistance2;
  
          var topThreshold = topDistanceTotal + 100;
          var bottomThreshold = 350;
  
          if (scrollTop > topThreshold && scrollFromBottom > bottomThreshold) {
              $('.sticky_button').show();
          } else {
              $('.sticky_button').hide();
          }
          if (scrollTop > 15) {
              $('.show_sticky').show();
          }
      });
      $('.sticky_button .select_bundle').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
          scrollTop: 51
        }, 600);
      });
  
  
  });
  
  // Handle gallery change between steps
  
  jQuery(function($) {
    var $el = $('.second_step_left');
    if (!$el.length) return;
  
    var THRESHOLD = 122;
    var TOP_TOLERANCE = 5;
    var isFixed = false;
    var armed = false;
    var originalStyleAttr = $el.attr('style') || '';
  
    function elementIsVisible() {
      return $el.length && $el.is(':visible') && $el.outerHeight() > 0 && $el.outerWidth() > 0;
    }
  
    function applyFixedBox() {
      var $p = $el.parent();
      var left = $p.offset() ? $p.offset().left : $el.offset().left;
  
      // Keep only position + top + left. Let CSS handle width.
      $el.css({
        position: 'fixed',
        top: 0,
        left: left
      });
    }
  
    function fixNow() {
      if (isFixed) return;
      isFixed = true;
      applyFixedBox();
    }
  
    function unfixNow() {
      if (!isFixed) return;
      isFixed = false;
      if (originalStyleAttr) $el.attr('style', originalStyleAttr);
      else $el.removeAttr('style');
    }
  
    function maybeArmAtTop() {
      var atTop = $(window).scrollTop() <= TOP_TOLERANCE;
      if (!armed && atTop && elementIsVisible()) {
        armed = true;
      }
    }
  
    function onScroll() {
      maybeArmAtTop();
      if (!armed) return;
      if ($(window).scrollTop() >= THRESHOLD) fixNow();
      else unfixNow();
    }
  
    $(window).on('scroll', onScroll);
    $(window).on('resize orientationchange', function() {
      if (isFixed) applyFixedBox();
    });
  
    maybeArmAtTop();
    onScroll();
  });
  
  
  
  //Change variant title case
  
  jQuery(function($){
    $('.variant-title').each(function(){
      var text = $(this).text().toLowerCase();
      text = text.replace(/\b\w/g, function(match){
        return match.toUpperCase();
      });
      $(this).text(text);
    });
  });
  
  
  // Hide Checkout Button on mobile until the user gets to the bottom
  
  /*
  
  jQuery(function($) {
    var $el = $('.checkout_button_wrapper');
    if (!$el.length) return;
  
    function toggleButton() {
      var winW = $(window).width();
      if (winW >= 768) {
        $el.show(); // Always visible on desktop
        return;
      }
  
      var scrollTop = $(window).scrollTop();
      var windowHeight = $(window).height();
      var documentHeight = $(document).height();
      var distanceFromBottom = documentHeight - (scrollTop + windowHeight);
  
      if (distanceFromBottom <= 400) {
        $el.fadeIn(200);
      } else {
        $el.fadeOut(200);
      }
    }
  
    $(window).on('scroll resize orientationchange', toggleButton);
    toggleButton(); // run once on load
  });
  
  */
  
  // Handle tabs
  
  jQuery(function($) {
    $('.upper_tabs').on('click', '> div > h3', function() {
      var $h3 = $(this);
      var $content = $h3.next('div');
  
      if ($content.is(':visible')) {
        $content.slideUp(200);
        $h3.removeClass('tab_active');
      } else {
        $content.slideDown(200);
        $h3.addClass('tab_active');
      }
    });
  });
  
  // Filter included items by swatch word match + sync checkout variant
  jQuery(function($) {
    var included1Variants = [];
    var included2Variants = [];
    try {
      var $included1Json = $('#included-1-product-variants');
      if ($included1Json.length) {
        included1Variants = JSON.parse($included1Json.text());
      }
    } catch (e) {
      included1Variants = [];
    }
    try {
      var $included2Json = $('#included-2-product-variants');
      if ($included2Json.length) {
        included2Variants = JSON.parse($included2Json.text());
      }
    } catch (e) {
      included2Variants = [];
    }
  
    function filterIncludedBySwatch($btn) {
      var swatchValue = $btn.attr('value') || $btn.val() || '';
  
      $('.included_items > div').each(function() {
        var $group = $(this);
        var $items = $group.children('.included_item');
        if (!$items.length) return;
  
        var $matches = $items.filter(function() {
          var itemValue = String($(this).attr('value') || '').trim().toLowerCase();
          var swatch = String(swatchValue).trim().toLowerCase();
          return itemValue === swatch || itemValue.split(' / ')[0] === swatch;
        });
  
        // Only update groups that have at least one match for this swatch
        if (!$matches.length) return;
  
        $items.hide();
        $matches.show();
      });
    }
  
    function getSelectedSwatchValues($scope) {
      if (!$scope || !$scope.length) $scope = $('.product_toggle_button.selected');
      if (!$scope.length) $scope = $(document);
  
      return $scope.find('.swatch_button.selected').map(function() {
        return $(this).attr('value') || $(this).val() || '';
      }).get().filter(Boolean);
    }
  
    function findMatchingVariant(selectedValues, variants, preferNeedle) {
      if (!selectedValues.length || !variants || !variants.length) return null;
  
      var fallback = null;
      for (var i = 0; i < variants.length; i++) {
        var title = String(variants[i].title || '').toLowerCase();
        var allMatch = selectedValues.every(function(val) {
          return title.indexOf(String(val).toLowerCase()) !== -1;
        });
        if (!allMatch) continue;
        if (preferNeedle && title.indexOf(preferNeedle) !== -1) return variants[i];
        if (!fallback) fallback = variants[i];
        if (!preferNeedle) return variants[i];
      }
      return fallback;
    }
  
    function writeCheckoutLines($links, lines) {
      if (!lines) return;
      $links.each(function() {
        var href = $(this).attr('href') || '';
        var pattern = lines.indexOf(',') === -1
          ? /\/cart\/\d+:\d+/
          : /\/cart\/\d+:\d+(,\d+:\d+)?/;
        $(this).attr('href', href.replace(pattern, '/cart/' + lines));
      });
    }
  
    function updateTaylorPreorder() {
      $('.choose_first_product, .choose_second_product').each(function() {
        var $wrapper = $(this);
        var $h3 = $wrapper.find('h3');
        var $btn = $wrapper.find('.swatch_button.selected, .image-swatch.selected').first();
        var $msg = $h3.find('pre-order-message');
        var isOos = $btn.length && parseInt($btn.attr('data-inventory'), 10) <= 0;

        if (isOos) {
          var ship = $.trim($btn.attr('data-ship-date') || '');
          var text = ship ? ('Pre-order: Est. Ship Date ' + ship) : 'Pre-order';
          if (!$msg.length) {
            $msg = $('<pre-order-message></pre-order-message>');
            $h3.find('span').after($('<br>'), $msg);
          }
          $msg.text(text);
        } else {
          $h3.find('br').remove();
          $msg.remove();
        }
      });
    }

    function updateCheckoutVariant() {
      var $firstCard = $('.product_toggle_buttons .product_toggle_button:first-child');
      var $lastCard = $('.product_toggle_buttons .product_toggle_button:last-child');
  
      var match1 = findMatchingVariant(
        getSelectedSwatchValues($lastCard.find('.choose_first_product')),
        included1Variants,
        '10x magnifying mirror'
      );
      var match2 = findMatchingVariant(
        getSelectedSwatchValues($lastCard.find('.choose_second_product')),
        included2Variants
      );
      if (match1 && match2) {
        writeCheckoutLines($('.checkout_link'), match1.id + ':1,' + match2.id + ':1');
      }
  
      var soloMatch = findMatchingVariant(
        getSelectedSwatchValues($firstCard),
        included1Variants,
        '10x magnifying mirror'
      );
      if (soloMatch) {
        writeCheckoutLines($('.checkout_link_3'), soloMatch.id + ':1');
      }
    }
  
    $(document).on('click', '.swatch_button', function() {
      var $btn = $(this);
      $btn.siblings('.swatch_button').removeClass('selected');
      $btn.addClass('selected');
      filterIncludedBySwatch($btn);
      updateCheckoutVariant();
      updateTaylorPreorder();
    });
  
    // Apply preselected swatches on load
    $('.swatch_button.selected').each(function() {
      filterIncludedBySwatch($(this));
    });
    updateCheckoutVariant();
    updateTaylorPreorder();
  });
  
  $(function () {
    $('.choose_first_product').each(function () {
      const $wrapper = $(this);
      const $swatches = $wrapper.find('.swatch_button');
      const $label = $wrapper.find('h3 span');
  
      // Display the initially selected swatch value
      $label.text($swatches.filter('.selected').first().val());
  
      $swatches.on('click', function (event) {
        event.preventDefault();
  
        $swatches.removeClass('selected');
        $(this).addClass('selected');
  
        $label.text($(this).val());
      });
    });
  });
  
  $(function () {
    $('.choose_second_product').each(function () {
      const $wrapper = $(this);
      const $swatches = $wrapper.find('.image-swatch');
      const $label = $wrapper.find('h3 span');
  
      // Display the initially selected swatch value
      $label.text($swatches.filter('.selected').first().val());
  
      $swatches.on('click', function (event) {
        event.preventDefault();
  
        $swatches.removeClass('selected');
        $(this).addClass('selected');
  
        $label.text($(this).val());
      });
    });
  });
  
  $('.video_wrapper').on('click', function() {
      var videoUrl = $(this).data('url');
      var $modal = $('.video_modal_testimonials');
      var $videoContainer = $modal.find('.video_container').filter(function() {
          return $(this).data('url') === videoUrl;
      });
  
      $modal.css('display', 'flex');
      $videoContainer.show();
      $videoContainer.find('video').get(0).play();
  });
  
  function closeVideoModal() {
      var $modal = $('.video_modal_testimonials');
  
      $modal.find('video').each(function() {
          this.pause();
          this.currentTime = 0;
      });
  
      $modal.find('.video_container').hide();
      $modal.hide();
  }
  
  $('.close_modal').on('click', function() {
      closeVideoModal();
  });
  
  $('.video_modal_testimonials').on('click', function(e) {
      if ($(e.target).is('.video_modal_testimonials')) {
          closeVideoModal();
      }
  });
  
  $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && $('.video_modal_testimonials').is(':visible')) {
          closeVideoModal();
      }
  });
  
  // Product Toggle Checks
  
  var $firstButton = $('.product_toggle_buttons .product_toggle_button:first-child');
  var $lastButton = $('.product_toggle_buttons .product_toggle_button:last-child');
  var $firstButtonSwatches = $firstButton.children('div');
  var $lastButtonSwatches = $lastButton.children('div');
  var animationSpeed = 180;
  
  $firstButton.on('click', function () {
    if ($(this).hasClass('selected')) {
      return;
    }
  
    $(this).addClass('selected');
    $lastButton.removeClass('selected');
  
    $('.included_items > div:last-child').css('opacity', '0.3');
    $('.product_toggle_buttons > .product_toggle_button > div').css('opacity', '0.3');
  
    $('.product_toggle_1').hide();
    $('.product_toggle_2').show();
  
    $lastButtonSwatches
      .stop(true, false)
      .css('overflow', 'hidden')
      .animate({
        height: 0,
        opacity: 0
      }, animationSpeed, function () {
        $(this).hide();
      });
  
  
    $firstButtonSwatches
      .stop(true, false)
      .show()
      .css({
        height: 'auto',
        opacity: 0,
        overflow: 'hidden'
      });
  
    var fullHeight = $firstButtonSwatches.height();
  
    $firstButtonSwatches
      .height(0)
      .animate({
        height: fullHeight,
        opacity: 1
      }, animationSpeed, function () {
        $(this).css({
          height: '',
          opacity: '',
          overflow: ''
        });
      });
  });
  
  $lastButton.on('click', function () {
    if ($(this).hasClass('selected')) {
      return;
    }
  
    $(this).addClass('selected');
    $firstButton.removeClass('selected');
  
    $('.included_items > div:last-child').css('opacity', '1');
    $('.product_toggle_buttons > .product_toggle_button > div').css('opacity', '1');
  
    $('.product_toggle_1').show();
    $('.product_toggle_2').hide();
  
    $firstButtonSwatches
      .stop(true, false)
      .css('overflow', 'hidden')
      .animate({
        height: 0,
        opacity: 0
      }, animationSpeed, function () {
        $(this).hide();
      });
  
    $lastButtonSwatches
      .stop(true, false)
      .show()
      .css({
        height: 'auto',
        opacity: 0,
        overflow: 'hidden'
      });
  
    var fullHeight = $lastButtonSwatches.height();
  
    $lastButtonSwatches
      .height(0)
      .animate({
        height: fullHeight,
        opacity: 1
      }, animationSpeed, function () {
        $(this).css({
          height: '',
          opacity: '',
          overflow: ''
        });
      });
  });